import { render, staticRenderFns } from "./landingpages-add-or-update.vue?vue&type=template&id=66b4d145&scoped=true&"
import script from "./landingpages-add-or-update.vue?vue&type=script&lang=js&"
export * from "./landingpages-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./landingpages-add-or-update.vue?vue&type=style&index=0&id=66b4d145&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4d145",
  null
  
)

export default component.exports